
import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmService } from '../confirm/confirm.service';
import { ImportarProductosService } from './importar-productos.service';
import { ImportarRepuestosService } from './importar-repuestos.service';

@Component({
  selector: 'app-listado-repuestos',
  templateUrl: './listado-repuestos.component.html',
  styleUrls: ['./listado-repuestos.component.css']
})
export class ListadoRepuestosComponent implements OnInit {

  constructor(private service : UserService, private toast: ToastrService, private confirm : ConfirmService, private importarProductosService: ImportarProductosService, private importarRepuestosService: ImportarRepuestosService) { }

  productos = [];
  repuestos = [];

  productSearchText = "";
  productSearchResult = [];
  
  buscarProducto(){
    console.log('asd');
    this.productSearchText = this.productSearchText.toUpperCase();
    this.productSearchResult = this.productos.filter(x=>x.nombre.toUpperCase().includes(this.productSearchText));
    console.log(this.productSearchResult.length);
    
  }


  productoSeleccionado;

  ngOnInit() {
    this.getProductos();
  }

  getProductos(){
    this.service.getProductos().subscribe(d=>{
      this.productos = d.productos;
      this.productos = this.productos.sort( (a,b) => { return a.barcode < b.barcode ? 1 : -1 } );
      if(this.productos.length>0)this.productoSeleccionado = this.productos[0].codigo;
      this.getRepuestos();
    }, er=> { this.toast.error("ERROR")})
  }

  getRepuestos(){
    this.service.getProductRepuestos(this.productoSeleccionado).subscribe(d=>{
      this.repuestos = d.repuestos;
      this.repuestos.sort(function(a,b){ return a.nombre > b.nombre ? 1: -1 });
    })
    
  }


  producto_editado;
  nuevoProducto(){
    this.producto_editado = { nombre: "", barcode: "" , codigo: ""};
  }
  editarProducto(){
    this.producto_editado = JSON.parse(JSON.stringify(this.productos.find(x=>  x.codigo == this.productoSeleccionado ) ));
    console.log(this.producto_editado);
    
  }

  guardarProducto(){
    if(this.producto_editado._id){
      this.service.updateProducto(this.producto_editado._id, this.producto_editado.nombre, this.producto_editado.codigo, this.producto_editado.barcode).subscribe(d=>{
        let aux = this.productos.find(x=>  x._id == this.producto_editado._id);
        aux.nombre = this.producto_editado.nombre;
        aux.codigo = this.producto_editado.codigo;
        aux.barcode = this.producto_editado.barcode;
        this.producto_editado = null;
        this.getRepuestos();
      }, er=>{
        this.toast.error(er.error,"Error");
      })
    }
    else{
      this.service.postProducto(this.producto_editado.nombre, this.producto_editado.codigo, this.producto_editado.barcode).subscribe(d=>{
       this.productos.push(d);
        this.producto_editado = null;
        this.productoSeleccionado = d.codigo;
        this.getRepuestos();
      }, er=>{
        this.toast.error(er.error,"Error");
      })
    }
  }


  nuevoRepuesto: any = { codigo: "", nombre: ""};
  eliminarRepuesto(r){
    let p = this.productos.find( x=> x.codigo == r.producto.codigo);
    if(!p) return;
    this.confirm.confirm("Eliminar repuesto", "Esta seguro de eliminar el repuesto " + r.nombre + " (" + r.codigo + ") del producto " +  p.nombre + " (" + p.codigo + ") ?" , "Eliminar", "Cancelar").then( confirmed=>{
      if(!confirmed) return;
      this.service.deleteRepuesto(r._id).subscribe(d=>{
        this.getRepuestos();
      }, er=>{
        this.toast.error(er.error,"Error");
      })
      
    })
  }

  agregarRepuesto(){
    let p = this.productos.find( x=> x.codigo == this.productoSeleccionado);
    if(!p) return;

    this.nuevoRepuesto.producto = { codigo : p.codigo ,  nombre: p.nombre };

    this.service.postRepuesto(this.nuevoRepuesto).subscribe(d=>{
      this.repuestos.push(d);
    }, er=>{
      this.toast.error(er.error,"Error");
    })
    
    this.nuevoRepuesto = { codigo: "", nombre: ""};
  }

  getProductosErroneos(){
    return this.productos.filter(x=> !x.barcode || x.barcode.length!=6);
  }


  elimninarProducto(){
    let p = this.productos.find( x=> x.codigo == this.productoSeleccionado);
    if(!p) return this.toast.error("Debes selecionar un producto");
    this.confirm.confirm("Eliminar producto", "Esta seguro que desea eliminar el producto :"  + p.barcode + ' - ' + p.nombre + ' (' + p.codigo + " )").then(confirmed =>{
      if(!confirmed) return;
      this.service.deleteProducto(p._id).subscribe(d=>{
        this.toast.success("Producto eliminado");
        this.ngOnInit()
      }, er=>{
        this.toast.error(er.error);
      })
    });
  }

  //REPUESTOS
  getCsv(){
    this.service.getRepuestosCsv().subscribe(d=>{
      this.createCsv(d);
    }, er=>{
      this.createCsv(er.error.text);
    })
  }

  createCsv(content){
    var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(content));
      element.setAttribute('download', "Repuestos.csv");
  
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
  }

  //PRODUCTOS
  getCsv2(){
    this.service.getProductosCsv().subscribe(d=>{
      this.createCsv2(d);
    }, er=>{
      this.createCsv2(er.error.text);
    })
  }

  createCsv2(content){
    var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(content));
      element.setAttribute('download', "Productos.csv");
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
  }



  importarProductos(){

    //SE IMPORTA CSV CON FORMATO : prod_code |	prod_name	 | prod_ns | 	rep_code | 	rep_name
    this.importarProductosService.show("Importar productos", "", "OK", "Cancelar", "lg").then( result =>{
      console.log("Success");
      this.getProductos();
      
    }).catch( error =>{
      console.log("ERROR");
      
    })
  }

  importarRepuestos(){
    this.importarRepuestosService.show("Importar productos", "", "OK", "Cancelar", "lg").then( result =>{
      console.log("Success");
      this.getProductos();
      
      
    }).catch( error =>{
      console.log("ERROR");
      
    })
  }
}
